import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { LeaderLevelModel } from "../_models/leader-level.model";
import { environment } from "../../../../environments/environment";

const API_LEADERLEVELS_URL = environment.API_URL + "api/leaderlevels";

@Injectable({
  providedIn: "root"
})
export class LeaderLevelService {
  // TODO: NGRX error handling

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  // CREATE =>  POST: add a new leaderLevel to the server
  createLeaderLevel(leaderLevel): Observable<LeaderLevelModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http
      .post<LeaderLevelModel>(API_LEADERLEVELS_URL, leaderLevel, {
        headers: httpHeaders
      })
      .pipe(catchError((err) => of(null)));
  }

  // Server should return filtered/sorted result
  findLeaderLevels(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_LEADERLEVELS_URL + "/find";
    return this.http
      .post<QueryResultsModel>(url, queryParams, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  // Server should return filtered/sorted result
  getLeaderLevels(): Observable<LeaderLevelModel[]> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.get<LeaderLevelModel[]>(API_LEADERLEVELS_URL, {
      headers: httpHeaders
    });
  }

  // UPDATE => PUT: update the leaderLevel on the server
  updateLeaderLevel(leaderLevel: LeaderLevelModel): Observable<any> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    let url = `${API_LEADERLEVELS_URL}/${leaderLevel.id}`;
    return this.http.put(url, leaderLevel, { headers: httpHeaders }).pipe(catchError((err) => of(null)));
  }

  // DELETE => delete the leaderLevel from the server
  deleteLeaderLevel(leaderLevelId: number): Observable<LeaderLevelModel> {
    const url = `${API_LEADERLEVELS_URL}/${leaderLevelId}`;
    return this.http.delete<LeaderLevelModel>(url).pipe(catchError((err) => of(null)));
  }
}
